import * as React from 'react';

interface RenderPointsRelaisProps {
  shippingPoint: any;
}

export class RenderPointRelai extends React.Component<RenderPointsRelaisProps, Record<string, unknown>> {

  constructor(props: RenderPointsRelaisProps) {
    super(props);

    this.state = {};
  }

  _displayHoraires = () => {
    const div = document.getElementById(this.props.shippingPoint.id);

    if(!div) return;

    if (div.style.display === 'none') {
      div.style.display = 'block';
    } else {
      div.style.display = 'none';
    }
  }

  render() {
    const renderHoraires = (horaires: any, id: string) => {
      const tab = [];
      for (const horaire in horaires) {
        tab.push(
          <div key={horaire} className="d-flex font12">
            <div>
              {horaire.substr(0, 1).toUpperCase() + horaire.substr(1, horaire.length).toLowerCase()}
              :&nbsp;
            </div>
            <div>{horaires[horaire]}</div>
          </div>,
        );
      }

      return (
        <div id={id} style={{ display: 'none' }} className="pl-5 grey">
          {tab}
        </div>
      );
    };

    return (
      <div className="col-lg-9 col-md-9 col-12">
        <p className="m-0 bold font14 cursor-pointer">
          {this.props.shippingPoint.name} ({this.props.shippingPoint.distance}Km)
        </p>
        <p className="m-0 font12">{this.props.shippingPoint.street}</p>
        <p className="m-0 font12">
          <span>{this.props.shippingPoint.zipCode}</span>
          <span>&nbsp;{this.props.shippingPoint.city}</span>
        </p>
        <p className="m-0 font12 cursor-pointer text-underline" onClick={this._displayHoraires}>Les horaires</p>
        {renderHoraires(this.props.shippingPoint.hourly, this.props.shippingPoint.id)}
      </div>
    );
  }
}
